import React, { useEffect, useState } from 'react';
import './CookieNotice.css';
//import file from "../../documents/Политика в отношении файлов cookies job_ertelecom_ru.pdf"

const COOKIE_KEY = 'cookiesAccepted';
const COOKIE_EXPIRY_HOURS = 24;

function CookieNotice() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const raw = localStorage.getItem(COOKIE_KEY);
        if (raw) {
            const expiry = parseInt(raw, 10);
            if (!isNaN(expiry) && Date.now() < expiry) {
                setVisible(false);
                return;
            }
        }
        setVisible(true);
    }, []);

    function handleAccept() {
        const expiry = Date.now() + COOKIE_EXPIRY_HOURS * 60 * 60 * 1000;
        localStorage.setItem(COOKIE_KEY, String(expiry));
        setVisible(false);
    }

    if (!visible) return null;

    return (
        <div className="cookie-notice">
            <p>
                Мы используем cookies для улучшения работы сайта. Продолжая пользоваться сайтом, вы соглашаетесь с их использованием и <a href="/files/Политика%20в%20отношении%20файлов%20cookies%20job_ertelecom_ru.pdf" target="_blank" color="#00000">Политикой в отношении файлов cookies</a>.
            </p>
            <button
                className="cookie-notice__button"
                onClick={handleAccept}
            >
                Принять
            </button>
        </div>
    );
}

export default CookieNotice;


// WEBPACK FOOTER //
// ./src/components/CookieNotice/CookieNotice.js